<nav class="navbar navbar-expand-lg navbar-light bg-white fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/"><img src="assets/curb-logo.png" alt="Curb Logo" height="36"><span class="ms-2" style="color: #0052C9; font-size: 36px; font-weight: 500; vertical-align: middle; display: inline-block;">Fleet Administrator</span></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto">
        <li class="nav-item">
          <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
        </li>
        <li class="nav-item" *ngIf="isAuthenticated">
          <a class="nav-link" routerLink="/locations" routerLinkActive="active">Locations</a>
        </li>
        <li class="nav-item" *ngIf="isAuthenticated">
          <a class="nav-link" routerLink="/location-alerts" routerLinkActive="active">Location Alerts</a>
        </li>
        <li class="nav-item" *ngIf="isAuthenticated">
          <a class="nav-link" routerLink="/non-location-alerts" routerLinkActive="active">Non-Location Alerts</a>
        </li>
      </ul>
      <div class="d-flex">
        <ng-container *ngIf="!isAuthenticated">
          <button class="btn btn-outline-dark" (click)="login()">Login</button>
        </ng-container>
        <ng-container *ngIf="isAuthenticated">
          <div class="dropdown">
            <button class="btn btn-outline-dark dropdown-toggle" type="button" id="userDropdown" data-bs-toggle="dropdown" aria-expanded="false">
              {{ userProfile?.name || userProfile?.email || 'User' }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li><a class="dropdown-item" href="javascript:void(0)">Profile</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Logout</a></li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</nav>
